import React, { useEffect, useState } from 'react';
import { List, Card, Avatar, Button, Input, Space, Typography, Drawer, Dropdown, message, Modal } from 'antd';
import { MessageOutlined, CloseOutlined, SendOutlined, MoreOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CreateAnnounce from './CreateAnnounce';
import { AnnounceServices } from '../../Services/Room/AnnounceServices';
import { ENDPOINT } from '../../Services/ENDPOINT';
import useModal from 'antd/es/modal/useModal';
import useMessage from 'antd/es/message/useMessage';

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const ListAllAnnouncement = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [messageModal, setMessageModal] = useState(null);
  const [message, setMessage] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [announcement, setAnnouncements] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [drawerMode, setDrawerMode] = useState('create');
  const [modal, contextHolder] = Modal.useModal();
  const [msg, msgcontx] = useMessage();

  const getAllAnnouce = async () => {
    try {
      const request = await AnnounceServices.getAllAnnounce();
      console.log(request);
      setAnnouncements(request.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getAllAnnouce();
  }, [])

  const handleCreateAnnouncement = () => {
    setSelectedAnnouncement(null);
    setDrawerMode('create');
    setDrawerOpen(true);
  };

  const handleEditAnnouncement = (announcement) => {
    console.log(announcement);

    setSelectedAnnouncement(announcement);
    setDrawerMode('edit');
    setDrawerOpen(true);
  };

  const handleDeleteAnnouncement = async (announcementId) => {
    console.log(announcementId);

    try {
      modal.confirm({
        title: 'Delete Announcement',
        content: 'Are you sure you want to delete this announcement?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: async () => {
          await AnnounceServices.deleteAnnounce(announcementId);
          msg.success('Announcement deleted successfully');
          getAllAnnouce(); // Refresh the list
        }
      });
    } catch (error) {
      console.error('Error deleting announcement:', error);
      msg.error('Failed to delete announcement');
    }
  };

  const handleSendMessage = (addby_user_name) => {
    if (message.trim()) {
      alert(`Message sent to ${addby_user_name}: "${message}"`);
      setMessage('');
      setMessageModal(null);
    }
  };

  const handleDrawerClose = (shouldRefresh = false) => {
    setDrawerOpen(false);
    setSelectedAnnouncement(null);
    if (shouldRefresh) {
      getAllAnnouce(); // Refresh the list after successful create/edit
    }
  };

  const getMenuItems = (post) => [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: 'Edit',
      onClick: () => handleEditAnnouncement(post)
    },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      label: 'Delete',
      danger: true,
      onClick: () => handleDeleteAnnouncement(post.id)
    }
  ];

  const getDrawerTitle = () => {
    return drawerMode === 'create' ? 'Create Announcement' : 'Edit Announcement';
  };

  return (
    <div>
      <style jsx>{`
        .announcement-list {
          max-width: 672px;
          margin: 0 auto;
          padding: 24px 16px;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
      `}</style>
      {contextHolder}
      {msgcontx}
      <Card
        title={<Typography.Title level={3} style={{ margin: 0 }}>
          Announcements
        </Typography.Title>}
        extra={<Button size='large' type='primary' onClick={handleCreateAnnouncement}>Create Announcement</Button>}
      >
        <List
          style={{
            minWidth: '100px'
          }}
          className="announcement-list"
          dataSource={announcement}
          renderItem={(post) => (
            <List.Item>
              <Card
                hoverable
                style={{
                  width: '100%',
                  borderRadius: '12px',
                  border: '1px solid #f0f0f0',
                  overflow: 'hidden',
                }}
                bodyStyle={{ padding: 0 }}
              >
                {/* Post Header */}
                <div style={{ padding: '24px 24px 16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <Space size="middle" align="center">
                      <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" size={48} />
                      <div>
                        <Text strong style={{ color: '#1F1F1F', cursor: 'pointer', transition: 'color 0.3s' }}
                          onMouseEnter={(e) => e.target.style.color = '#1890FF'}
                          onMouseLeave={(e) => e.target.style.color = '#1F1F1F'}>
                          {post.addby_user_name}
                        </Text>
                        <br />
                        <Text style={{ fontSize: 12, color: '#8C8C8C' }}>
                          {post.addby_user_role} • {post.timestamp}
                        </Text>
                      </div>
                    </Space>
                    <Dropdown
                      menu={{ items: getMenuItems(post) }}
                      trigger={['click']}
                      placement="bottomRight"
                    >
                      <Button type="text" icon={<MoreOutlined style={{ color: '#595959' }} />} />
                    </Dropdown>
                  </div>
                </div>

                {/* Post description */}
                <div style={{ padding: '0 24px 16px' }}>
                  <Paragraph style={{ color: '#1F1F1F', lineHeight: '1.6', fontSize: '16px' }}>
                    {post.description}
                  </Paragraph>
                </div>

                {/* Images */}
                {post.image && (
                  <div style={{ position: 'relative' }}>
                    <img
                      src={`${ENDPOINT.base}/${post.image}`}
                      alt="announcement"
                      style={{ width: '100%', height: '192px', objectFit: 'cover', cursor: 'pointer' }}
                      onClick={() => setSelectedImage(`${ENDPOINT.base}/${post.image}`)}
                    />
                  </div>
                )}

                <div style={{
                  padding: '16px 24px',
                  borderTop: '1px solid #f0f0f0',
                  background: '#FAFAFA',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Space size="large">
                      {/* Like and comment buttons can be added here */}
                    </Space>
                    <Button
                      type="primary"
                      icon={<MessageOutlined />}
                      onClick={() => setMessageModal(post)}
                    >
                      Message
                    </Button>
                  </div>
                </div>
              </Card>
            </List.Item>
          )}
        />
      </Card>

      {/* Image Modal */}
      <Modal
        open={!!selectedImage}
        footer={null}
        centered
        closable={false}
        onCancel={() => setSelectedImage(null)}
        width="80%"
        style={{ top: 20 }}
      >
        <div style={{ position: 'relative' }}>
          <Button
            type="text"
            icon={<CloseOutlined style={{ color: 'white', fontSize: 24 }} />}
            onClick={() => setSelectedImage(null)}
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              zIndex: 10,
              backgroundColor: 'rgba(0,0,0,0.5)'
            }}
          />
          <img
            src={selectedImage}
            alt=""
            style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </div>
      </Modal>

      {/* Message Modal */}
      <Modal
        open={!!messageModal}
        onCancel={() => setMessageModal(null)}
        title={`Send Message to ${messageModal?.addby_user_name}`}
        footer={[
          <Button key="cancel" onClick={() => setMessageModal(null)}>
            Cancel
          </Button>,
          <Button key="send" type="primary" icon={<SendOutlined />} onClick={() => handleSendMessage(messageModal.addby_user_name)}>
            Send
          </Button>,
        ]}
      >
        <Space align="center" style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 8 }}>
          <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" size={48} />
          <div>
            <Text strong>{messageModal?.addby_user_name}</Text>
            <br />
            <Text type="secondary">{messageModal?.addby_user_role}</Text>
          </div>
        </Space>
        <TextArea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message..."
          rows={4}
        />
      </Modal>

      {/* Reusable Announcement Drawer */}
      <Drawer
        title={<Title level={4}>{getDrawerTitle()}</Title>}
        width={500}
        open={drawerOpen}
        onClose={() => handleDrawerClose(false)}
        destroyOnClose
      >
        <CreateAnnounce
          onClose={handleDrawerClose}
          editData={drawerMode === 'edit' ? selectedAnnouncement : null}
        />
      </Drawer>

    </div>
  );
};

export default ListAllAnnouncement;